var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcAccessTime = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "cheburator7",
    x: 0,
    y: 0,
    width: 1280,
    height: 1484
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-0.4%",
    y: "-0.3%",
    width: "100.8%",
    height: "100.7%",
    filterUnits: "objectBoundingBox",
    id: "cheburator6"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "shadowSpreadOuter2",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.12 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter3",
    result: "shadowBlurOuter3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.14 0",
    type: "matrix",
    in: "shadowBlurOuter3",
    result: "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter3"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "cheburator8",
    x: 0,
    y: 0,
    width: 1220,
    height: 42
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.9925,1.5 C4.8525,1.5 1.5,4.86 1.5,9 C1.5,13.14 4.8525,16.5 8.9925,16.5 C13.14,16.5 16.5,13.14 16.5,9 C16.5,4.86 13.14,1.5 8.9925,1.5 L8.9925,1.5 Z M9,3 C12.315,3 15,5.685 15,9 C15,12.315 12.315,15 9,15 C5.685,15 3,12.315 3,9 C3,5.685 5.685,3 9,3 Z M9.375,5.25 L8.25,5.25 L8.25,9.75 L12.1875,12.1125 L12.75,11.19 L9.375,9.1875 L9.375,5.25 Z",
    id: "cheburator9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "cheburator10",
    x: 0,
    y: 0,
    width: 37.5,
    height: 37.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cheburator",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cheburator5",
    transform: "translate(-603.000000, -578.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 1440,
    height: 1703
  }), /*#__PURE__*/React.createElement("rect", {
    id: "cheburator4",
    stroke: "#DFE2E5",
    fill: "#F7F8FA",
    x: -0.5,
    y: 123.5,
    width: 1441,
    height: 1580
  }), /*#__PURE__*/React.createElement("g", {
    id: "cheburator3",
    transform: "translate(80.000000, 139.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cheburator2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#cheburator6)",
    xlinkHref: "#cheburator7"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#cheburator7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cheburator15-14",
    transform: "translate(30.000000, 384.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cheburator18",
    transform: "translate(0.000000, 42.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "cheburator13",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cheburator8"
  })), /*#__PURE__*/React.createElement("use", {
    id: "cheburator14",
    fill: "#FFFFFF",
    xlinkHref: "#cheburator8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "cheburator15-10",
    mask: "url(#cheburator13)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(369.000000, 12.000000)",
    id: "cheburator15-22"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(123.000000, 0.000000)",
    id: "cheburator17"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "cheburator16",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cheburator9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cheburator14"
  }), /*#__PURE__*/React.createElement("g", {
    id: "cheburator15",
    mask: "url(#cheburator16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9.750000, -9.750000)",
    id: "cheburator11"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "cheburator19",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cheburator10"
  })), /*#__PURE__*/React.createElement("use", {
    id: "cheburator12",
    fill: "#BEC4CA",
    xlinkHref: "#cheburator10"
  })))))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcAccessTime, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-access-time.ecfa4a9d.svg";
export { ForwardRef as ReactComponent };